window.App = {
    W: $(window),
    D: $(document),
    H: $('html'),
    B: $('body'),
    ie: false,
    edge: false,
    firefox: false,
    mainpage: false
};


// Классы страницы
{
    if (App.H.hasClass('mobile')) {
        App.mobile = true;
    } else if (App.H.hasClass('safari') && 'ontouchstart' in window) {
        App.mobile = true;
        App.H.removeClass('osx').addClass('mobile ios');
    } else {
        App.H.addClass('desktop');
    }

    if (App.H.hasClass('ie')) {
        App.ie = true;
    }

    if (App.H.hasClass('edge')) {
        App.edge = true;
    }

    if (App.H.hasClass('firefox')) {
        App.firefox = true;
    }

    if (App.H.hasClass('page-main')) {
        App.mainpage = true;
    }

    // если юзается гуглокаптча, то формируем нужное состояния дял последующей проверки
    App.recaptchaAvailable = window.___grecaptcha_cfg !== undefined;
}

// пути для js библиотек
const DIR = '/js/libs/';
export const LIB_URL = {
    SWIPER:                DIR + 'swiper/swiper-bundle.min.js',
    MASONRY:               DIR + 'masonry.pkgd.min.js',
    JQ_INTLTELINPUT:       DIR + 'intlTelInput/intlTelInput.min.js',
    SPLIDE:                DIR + 'splide/splide.min.js',
    SPLIDE_AUTO_SCROLL:    DIR + 'splide/splide-extension-auto-scroll.min.js',
    JQ_FORM:               DIR + 'jquery.form.js',
    JQ_INPUTMASK:          DIR + 'jquery.inputmask.bundle.min.js',
    ION_RANGE_SLIDER:      DIR + 'ionRangeSlider/ion.rangeSlider.min.js',
    SELECT2:               DIR + 'select2/select2.full.min.js',
};
